import { defaultOptionalKeys } from 'bundles/apex/pipeline/config';

export const stagesDescription = {
  pitching: `You are chasing a listing or rep agreement with real opportunity to win.
    You're preparing a proposal/BOV, you've scheduled a pitch meeting, etc.`,
  sourcing: `You’ve won the listing or rep agreement.
    You're now sourcing potential buyers/tenants or properties/spaces for the client you represent.`,
  evaluating: `You've secured offers/LOIs or narrowed down the list of prospective properties/spaces,
    and you're reviewing these options with your client.`,
  transacting: `You have a signed contract or letter of intent,
    and you're working with the selected counterparty to finalize the transaction.`,
  closed: `The sale has closed or the lease agreement has been executed.
    You've earned a commission, though it may not be fully paid yet.`,
  dead: `You didn't win the listing or rep agreement, or the deal fell through and is no longer expected to close.`,
};

export const tabs = [
  { label: 'Pipeline Stages', value: 'stages' },
  { label: 'Pipeline View', value: 'view' },
];

export const brokerGrossOptions = [
  { label: 'Unweighted', value: 'unweighted' },
  { label: 'Weighted (Gross Commission x Close Probability)', value: 'weighted' },
];

export const defaultViewConfig = {
  brokerGross: 'unweighted',
  columns: defaultOptionalKeys,
};
